// LoginUtility.js

export function storeUserLogin() {
  localStorage.setItem('userLogin', 'true');
}

export function getUserLogin() {
  return localStorage.getItem('userLogin');
}

export function removeUserLogin() {
  return localStorage.removeItem('userLogin');
}

export function removeAllCookies() {
  // Clear non-sensitive session metadata state flags
  localStorage.removeItem('userLogin');
}

export function removeAllSession() {
  // Session storage is no longer used by the application
}
